<app-slider>
    <div appSliderItem *ngFor="let categoria of categorias">
        <div class="image-cont">
            <a (click)="openCategorySelected(categoria)">
                <div class="image">
                    <img [src]="categoria.image">
                    <div class="name-cont">
                        <div class="category-name">
                            <p>
                                {{ categoria.name }}
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</app-slider>
